import { render, staticRenderFns } from "./tabelas.vue?vue&type=template&id=14294b7e"
import script from "./tabelas.vue?vue&type=script&lang=js"
export * from "./tabelas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports